import createFormJson from '../../demo/fixtures/create-form.json'
import type { Objective } from '../../demo/types'
import { ChoiceCard, Icon } from '../../ui'
import styles from './CreatePage.module.css'

interface ObjectivePickerProps {
  value: Objective
  onChange: (value: Objective) => void
}

export function ObjectivePicker({ value, onChange }: ObjectivePickerProps) {
  return (
    <section className={styles.field} data-scope="create-objective-picker">
      <div className={styles.labelRow}>
        <span className={styles.label}>广告目标
          <span className={styles.help} title={createFormJson.objectiveHelp}><Icon name="help-circle" size={16} /></span>
        </span>
      </div>
      <div className={styles.choiceRow}>
        {createFormJson.objectives.map((item) => {
          const key = item.key as Objective
          return <ChoiceCard key={key} selected={value === key} icon={<Icon name={item.icon as 'cart' | 'eye'} size={22} />} title={item.label} subtitle={item.sub} unit={item.unit} onClick={() => onChange(key)} />
        })}
      </div>
    </section>
  )
}
